import { useExperimentContext } from "components/ExperimentProvider";
import {
  ExperimentFlags,
  PAGE_EXPERIMENT_NEW_PRODUCT_CARDS
} from "@shared/utils.experimentation";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";
import { useEffect } from "react";

export const useNewProductCard = () => {
  const { getValue } = useExperimentContext();
  const trackExperimentViewed = useExperimentViewed();
  const enabledVariants = [
    PAGE_EXPERIMENT_NEW_PRODUCT_CARDS.values.VARIANT,
    PAGE_EXPERIMENT_NEW_PRODUCT_CARDS.values.THROWAWAY_VARIANT
  ];
  const trackedVariant = [
    PAGE_EXPERIMENT_NEW_PRODUCT_CARDS.values.CONTROL,
    PAGE_EXPERIMENT_NEW_PRODUCT_CARDS.values.VARIANT
  ];
  const experimentValue = getValue(
    ExperimentFlags.PAGE_EXPERIMENT_NEW_PRODUCT_CARDS
  ) as number;

  useEffect(() => {
    if (trackedVariant.includes(experimentValue)) {
      trackExperimentViewed(
        ExperimentFlags.PAGE_EXPERIMENT_NEW_PRODUCT_CARDS,
        experimentValue
      );
    }
  }, [experimentValue]);

  return enabledVariants.includes(experimentValue);
};
